export default "__VITE_ASSET__ZG1Kghmo__"